import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

/**
 * formatDate.
 *
 * @param {Date | string | null | undefined} date
 * @param {string} [template] - 'DD/MM/YYYY'
 * @param {string} [locale] - 'fr'
 * @returns {string}
 */
export function formatDate(
  date: Date | string | null | undefined,
  template = 'DD/MM/YYYY',
  locale = 'fr',
  timezone = 'Europe/Paris',
): string {
  if (date === '') return '';
  return dayjs(date).tz(timezone).locale(locale).format(template);
}

/**
 * secondsSinceEpoch.
 * Get number of seconds since 01/01/1970. Usefull for token contracts.
 *
 * @param {Date} date
 * @returns {number}
 */
export function secondsSinceEpoch(date: Date): number {
  const utcMilllisecondsSinceEpoch = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
  const utcSecondsSinceEpoch = Math.round(utcMilllisecondsSinceEpoch / 1000);

  return utcSecondsSinceEpoch;
}
